import { DatePickerMobileSelectorColumnCellProps } from './props';
import styles from './styles.module.scss';
import { getDatePickerOptionLabel } from './helper';
import { memo } from 'react';
import { useTranslation } from '../../../../../../hooks';

/**
 * Component that renders an individual cell within a date picker selector column
 * Displays a date value (day, month or year) and handles styling for the currently selected item
 *
 * @component
 * @template T - Generic type for cell value
 * @param {Object} props - Component props
 * @param {T} props.value - Value to display in the cell
 * @param {boolean} props.isCurrent - Whether this cell is currently selected
 * @param {React.CSSProperties} props.style - CSS styles to apply to the cell
 * @param {'day'|'month'|'year'} props.type - Type of date value displayed
 * @returns {JSX.Element} Date picker cell with formatted value and styling
 */
function DatePickerMobileSelectorColumnCell<T>({
  value,
  isCurrent,
  style,
  type,
}: DatePickerMobileSelectorColumnCellProps<T>) {
  // Get translation function for month names
  const { t } = useTranslation('common');

  // Get formatted label for the date value
  const label = getDatePickerOptionLabel({ type }, value) as string;

  return (
    <div
      className={`${styles.cell} ${isCurrent ? styles['cell--current'] : ''}`}
      style={style}
    >
      {/* Translate month names, display other values directly */}
      {type == 'month' ? t(label) : label}
    </div>
  );
}

// Memoize component to prevent unnecessary re-renders
export default memo(
  DatePickerMobileSelectorColumnCell,
) as typeof DatePickerMobileSelectorColumnCell;
